import React, { createContext, useReducer } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import _ from 'lodash';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useAuth from 'app/hooks/useAuth';

const initialState = {
  verification: {},
  project: {},
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'VERIFY_TOKEN': {
      return {
        ...state,
        verification: action.payload,
      };
    }
    case 'VALIDATE_MAIL_TOKEN': {
      return {
        ...state,
        project: action.payload,
      };
    }
    case 'VALIDATE_COM_TOKEN': {
      return {
        ...state,
        project: action.payload,
      };
    }
    default: {
      return { ...state };
    }
  }
};

const VerifyContext = createContext({
  verification: {},
  project: {},
  ConnectionSecure: () => {},
  ValidateMailCode: () => {},
  ValidateComCode: () => {},
  VerifyToken: () => {},
  VerifyQrCode: () => {}
});

export const VerifyProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const navigate = useNavigate();

  const { setSession, dispatch: authDispatch } = useAuth();

  const ConnectionSecure = async (item) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_TRANSACTIONS}tracks/outside/credential`,
        { client_key: item },
        { headers: { 'Content-Type': 'application/json' } }
      );
      return res.data;
    } catch (ex) {
      return {
        success: false,
        message:
          'Internal server error, please contact your administrator !',
        errcode: 'INV_ERROR',
      };
    }
  };

  // const ValidateMailCode = async (token, code) => {
  //   try {
  //     const parameter = { client_secret: token, client_code: code };
  //     const res = await axios.post(
  //       `${process.env.REACT_APP_TRANSACTIONS}tracks/outside/validate/credential`,
  //       parameter,
  //       { headers: { 'Content-Type': 'application/json' } }
  //     );

  //     if (res.data.success) {
  //       dispatch({ type: 'VALIDATE_MAIL_TOKEN', payload: res.data.payload });

  //       const credential = res.data.payload.credential;
  //       const RoleApp = _.filter(credential.application, {
  //         AppId: parseInt(process.env.REACT_APP_KEY_ID),
  //       });

  //       alert(JSON.stringify(credential))
  //       alert(JSON.stringify(RoleApp))

  //       setSession(
  //         credential.token,
  //         JSON.stringify(credential.user),
  //         JSON.stringify(RoleApp)
  //       );

  //       authDispatch({
  //         type: 'LOGIN',
  //         payload: {
  //           user: credential.user,
  //           application: RoleApp,
  //           token: credential.token,
  //         },
  //       });

  //       return res.data;
  //     }else{
  //       return res.data;
  //     }
  //   } catch (ex) {
  //     return {
  //       success: false,
  //       message:
  //         'Internal server error, please contact your administrator !',
  //       payload: {},
  //     };
  //   }
  // };

  const ValidateMailCode = async (token, code) => {
    try {
      const parameter = { client_secret: token, client_code: code };

      const res = await axios.post(
        `${process.env.REACT_APP_TRANSACTIONS}tracks/outside/validate/credential`,
        parameter,
        {
          headers: { 'Content-Type': 'application/json' },
          validateStatus: (status) => true,
        }
      );

      const success =
        res?.data?.success === true || res?.data?.success === 'true';

      if (success && res.data.payload) {
        dispatch({ type: 'VALIDATE_MAIL_TOKEN', payload: res.data.payload });

        const credential = res.data.payload.credential;

        const RoleApp = _.filter(credential.application || [], {
          AppId: parseInt(process.env.REACT_APP_KEY_ID),
        });

        setSession(
          credential.token,
          JSON.stringify(credential.user),
          JSON.stringify(RoleApp)
        );

        authDispatch({
          type: 'LOGIN',
          payload: {
            user: credential.user,
            application: RoleApp,
            token: credential.token,
          },
        });

        return { success: true, payload: res.data.payload, message: res.data.message || 'Success' };
      } else {
        return {
          success: false,
          payload: res.data?.payload || {},
          message: res.data?.message || 'Invalid code or response from server',
        };
      }
    } catch (ex) {
      console.error("ValidateMailCode error:", ex);
      return {
        success: false,
        payload: {},
        message:
          'Internal server error, please contact your administrator!',
      };
    }
  };

  const ValidateComCode = async (token, code) => {
    try {
      const parameter = { client_secret: token, client_code: code };

      const res = await axios.post(
        `${process.env.REACT_APP_TRANSACTIONS}letters/outside/validate/credential`,
        parameter,
        {
          headers: { 'Content-Type': 'application/json' },
          validateStatus: (status) => true,
        }
      );

      const success =
        res?.data?.success === true || res?.data?.success === 'true';

      if (success && res.data.payload) {
        dispatch({ type: 'VALIDATE_COM_TOKEN', payload: res.data.payload });

        const credential = res.data.payload.credential;

        const RoleApp = _.filter(credential.application || [], {
          AppId: parseInt(process.env.REACT_APP_KEY_ID),
        });

        setSession(
          credential.token,
          JSON.stringify(credential.user),
          JSON.stringify(RoleApp)
        );

        authDispatch({
          type: 'LOGIN',
          payload: {
            user: credential.user,
            application: RoleApp,
            token: credential.token,
          },
        });

        return { success: true, payload: res.data.payload, message: res.data.message || 'Success' };
      } else {
        return {
          success: false,
          payload: res.data?.payload || {},
          message: res.data?.message || 'Invalid code or response from server',
        };
      }
    } catch (ex) {
      console.error("ValidateMailCode error:", ex);
      return {
        success: false,
        payload: {},
        message:
          'Internal server error, please contact your administrator!',
      };
    }
  };

  const VerifyToken = async (trackNumber, body) => {
    try {
      const res = await axios.post(
        process.env.REACT_APP_TRANSACTIONS +
          'tracks/verify/mailbox/' +
          trackNumber,
        body
      );

      if (res.data.success) {
        const { data, credential } = res.data.payload;
        const RoleApp = _.filter(credential.application, {
          AppId: parseInt(process.env.REACT_APP_KEY_ID),
        });

        setSession(
          credential.token,
          JSON.stringify(credential.user),
          JSON.stringify(RoleApp)
        );

        dispatch({ type: 'VERIFY_TOKEN', payload: res.data.payload });

        authDispatch({
          type: 'LOGIN',
          payload: {
            user: credential.user,
            application: RoleApp,
            token: credential.token,
          },
        });

        toast.success('Token verified successfully!', { theme: 'light' });

        navigate(`/tracking/${data.Type}/review`, {
          state: {
            Type: data.Type,
            TxCode: data.TxCode,
            GxCode: data.GxCode,
            Approval: parseInt(data.Approval),
          },
        });
      } else {
        toast.error(res.data.message, { theme: 'light' });
      }
    } catch (ex) {
      toast.error(ex.response?.data?.message || 'Verification failed', {
        theme: 'light',
        autoClose: 10000,
      });
      setTimeout(() => {
        navigate('/');
      }, 10000);
    }
  };

  const VerifyQrCode = async(token) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_TRANSACTIONS}tracks/outside/validate/qrcode/view`,
        { client_key: token },
        { headers: { 'Content-Type': 'application/json' } }
      );
      return res.data;
    } catch (ex) {
      return {
        success: false,
        message: 'Internal server error, please contact your administrator !',
        errcode: 'QR_ERROR',
      };
    }
  }

  return (
    <VerifyContext.Provider
      value={{
        verification: state.verification,
        project: state.project,
        VerifyToken,
        ConnectionSecure,
        ValidateMailCode,
        ValidateComCode,
        VerifyQrCode
      }}
    >
      {children}
      <ToastContainer position={toast.POSITION.TOP_RIGHT} />
    </VerifyContext.Provider>
  );
};

export default VerifyContext;
